export const fst = <A>(t: [A, ...any[]]) => t[0];
export const snd = <B>(t: [any, B, ...any[]]) => t[1];
